import React from 'react';

const TourserLength = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4482_182)">
            <path
                d="M7.09243 1.80592L17.1024 1.80591C18.2069 1.80591 19.1094 2.70565 19.0309 3.80741C18.5256 10.8955 15.4405 14.7365 14.6614 20.2687C14.5111 21.3364 13.6382 22.1941 12.56 22.1941H8.61629C7.58339 22.1941 6.7196 21.4075 6.62407 20.379L5.10187 3.99089C4.99296 2.81831 5.91481 1.80592 7.09243 1.80592Z"
                stroke="#323232"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.38525 5.46008H18.3931"
                stroke="#323232"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.99902 5.57117V21.97"
                stroke="#323232"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="1 3"
            />
            <path
                d="M14.2488 5.53394C14.3054 7.17917 13.3765 10.583 17.2552 10.583"
                stroke="#323232"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_4482_182">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default TourserLength;
